import {ConnectorStatusEnum} from 'src/enums';
import {CONNECTOR_STATUS_TYPE, ConnectorDTO} from 'src/types';

/**
 * What a connector is doing right now.
 *
 * Two authorities, in order: the charger as it was read when the page opened, then the websocket.
 * The row is matched on the connector's **database id**, which is what the server puts in the
 * message - the number shown to people is `connector.connectorId`, the socket's OCPP number, and
 * comparing against that one matches nothing at all.
 */
export const liveConnectorStatus = (
    rows: CONNECTOR_STATUS_TYPE[],
    chargerId: number,
    connector: ConnectorDTO
): ConnectorStatusEnum =>
    rows.find((row) => row.chargerId === chargerId && row.connectorId === connector.id)?.status
    ?? connector.currentStatus;

/**
 * Whether a session is running on it.
 *
 * Three states mean yes, and they differ only in who paused the session: nobody, the car, or the
 * station. All three are a car plugged in with energy accounted to someone.
 */
export const isSessionRunning = (status: ConnectorStatusEnum) =>
    status === ConnectorStatusEnum.CHARGING ||
    status === ConnectorStatusEnum.SUSPENDED_EV ||
    status === ConnectorStatusEnum.SUSPENDED_EVSE;
